import React from 'react'
import SocialLinks from '../components/sociallinks/SocialLinks'
import NavBar from '../components/navbar/NavBar'
import Footer from '../components/footer/Footer'
import DocBox from '../components/docbox/DocBox'

const Documents = () => {
    return (
        <>
            <SocialLinks />
            <NavBar />
            <div className="documents-div-main">
                <div className="container">
                    <div className="comming-soon documents">
                        {/* <h1>NEW VERSION OF WHITEPAPER SOON TO BE RELEASED.</h1> */}
                        <DocBox />
                    </div>
                </div>
            </div>
            <div className="instruction-div">
                <a href="https://pizza-nft.com/PizzaNFTWhitePaper.pdf" target="_blank">White Paper</a>
            </div>
            <Footer />

        </>
    )
}

export default Documents
